import React, { useCallback, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { CropperRef, Cropper } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import { cmsAccount, msHeaders } from "./NavMenu";
import "./css/MyDropzone.css";

export function MyDropzone({ updateImages }) {
    const cropperRef = useRef(null);
    const [image, setImage] = useState("");
    const [cropperEnabled, setCropperEnabled] = useState(false);
    const [files, setFiles] = useState([]);
    const [imageIndex, setImageIndex] = useState(0);

    const onReady = (cropper) => {
        const image = cropper.getImage();
        cropper.setCoordinates({
            width: image.width,
        });
    };

    const flip = (horizontal, vertical) => {
        if (cropperRef.current) {
            cropperRef.current.flipImage(horizontal, vertical);
        }
    };
    const rotate = (angle) => {
        if (cropperRef.current) {
            cropperRef.current.rotateImage(angle);
        }
    };
    const save = () => {
        if (cropperRef.current) {
            cropperRef.current.getCanvas().toBlob((newblob) => {
                const oldFile = files[imageIndex];
                const newFile = new File([newblob], oldFile.name, { type: oldFile.type });
                files[imageIndex] = newFile;
                setImage(cropperRef.current.getCanvas().toDataURL());
            });
        }
    };

    const uploadFiles = () => {
        files.forEach((file, index) => {
            const blob = new Blob([file]);
            const blobName = file.name;
            var formdata = new FormData();
            formdata.append("companyUUID", cmsAccount.companyUUID);
            formdata.append("file", file);
            var requestOptions = {
                method: "POST",
                headers: msHeaders,
                body: formdata,
                redirect: "follow",
            };
            fetch(`/api/images/upload`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.id) {
                        const img = new Image();
                        img.src = URL.createObjectURL(blob);
                        const imgObj = {
                            imageSrc: img.src,
                            name: result.fileName.replace(/\.[^/.]+$/, "") + ".jpg",
                            orientation: img.width >= img.height ? "Landscape" : "Portrait",
                        };
                        img.onload = () => {
                            updateImages(imgObj);
                        };
                    } else {
                        alert(`${blobName}: ${result}`);
                    }
                });
        });
    };

    const onDrop = useCallback((acceptedFiles) => {
        setCropperEnabled(true);
        setFiles(acceptedFiles);

        acceptedFiles.forEach((file, index) => {
            const blob = new Blob([file]);
            const url = URL.createObjectURL(blob);
            if (index == 0) setImage(url);
        });
    }, []);

    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <>
            <div {...getRootProps()} className="drag-zone-hover">
                <input {...getInputProps()} />
            </div>

            {cropperEnabled ? (
                <div className="image-cropper-bg">
                    <div className="ms-3 w-50 d-flex justify-content-end">
                        <button
                            onClick={() => {
                                setCropperEnabled(false);
                            }}
                        >
                            <span className="material-symbols-outlined text-white">close</span>
                        </button>
                    </div>
                    <div className="image-cropper">
                        <Cropper
                            ref={cropperRef}
                            src={image}
                            aspectRatio={{ minimum: 16 / 9, maximum: 16 / 9 }}
                            onReady={onReady}
                        />
                    </div>
                    <div className="cropper-navigation">
                        <button
                            className="square-button"
                            onClick={() => {
                                flip(true, false);
                            }}
                        >
                            <img src={"icons/flip-horizontal.svg"} />
                        </button>
                        <button
                            className="square-button"
                            onClick={() => {
                                rotate(-90);
                            }}
                        >
                            <img src={"icons/rotate-counter-clockwise.svg"} />
                        </button>
                        <button
                            className="square-button"
                            onClick={() => {
                                rotate(90);
                            }}
                        >
                            <img src={"icons/rotate-clockwise.svg"} />
                        </button>
                        <button
                            className="square-button"
                            onClick={() => {
                                flip(false, true);
                            }}
                        >
                            <img src={"icons/flip-vertical.svg"} />
                        </button>
                        <button
                            className="square-button"
                            onClick={() => {
                                save();
                            }}
                        >
                            <span class="material-symbols-outlined">check</span>
                        </button>
                    </div>
                    <div className="image-list bg-black d-flex">
                        {files.map((file, index) => {
                            const blob = new Blob([file]);
                            const url = URL.createObjectURL(blob);
                            return (
                                <div
                                    className="btn"
                                    onClick={() => {
                                        setImage(url);
                                        setImageIndex(index);
                                    }}
                                >
                                    <img src={url} height={75} />
                                </div>
                            );
                        })}
                    </div>
                    <button
                        className="btn btn-primary d-flex gap-2"
                        onClick={() => {
                            uploadFiles();
                            setCropperEnabled(false);
                        }}
                    >
                        <span class="material-symbols-outlined">cloud_upload</span>
                        upload images
                    </button>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
